import { createAction } from '@reduxjs/toolkit'
import { call, ForkEffect, put, select, takeEvery } from 'redux-saga/effects'

import { fetchDocumentChunksAndMappings } from './data-prep/prepareMarkupData'
import { updateDocumentMappingDataToConformToAPI } from './updateSingleDocumentMapping'
import { duplicateDocumentChunk } from '../../../api/projects-api'
import { updateDocumentMapping } from '../../../api/takeoff-api'
import { DocumentChunk } from '../../../models/documentChunk'
import { DocumentMapping } from '../../../models/documentMapping'
import { Project } from '../../../models/project'
import {
    initializeDocumentChunks,
    initializeProjectDocumentsFromChunks,
    selectDocumentChunks,
    selectDocumentMappings,
    updateDocumentMappings,
} from '../../slices/documents'
import { selectProject } from '../../slices/project'

export const duplicateDocumentChunkAction = createAction<{ documentChunkId: number }>('duplicateDocumentChunk')

export function* handleDuplicateDocumentChunk({ payload }: ReturnType<typeof duplicateDocumentChunkAction>) {
    const documentChunks: DocumentChunk[] = yield select(selectDocumentChunks)
    const documentMappings: DocumentMapping[] = yield select(selectDocumentMappings)
    const project: Project = yield select(selectProject)

    try {
        const { document_chunk_mappings: documentMapping } = yield call(
            duplicateDocumentChunk,
            project.id,
            payload.documentChunkId
        )

        const mapping = documentMapping[0]

        const modifiedMapping = project.is_master_set
            ? {
                  ...mapping,
                  is_estimation_complete: false,
                  building_id: mapping.building_id,
                  additional_data: {
                      ...mapping.additional_data,
                      baseHomes: undefined,
                      options: undefined,
                      estimatedBaseHomeId: undefined,
                  },
                  overlay_center: [0, 0],
                  overlay_rotation: 0,
                  overlay_scale: 0,
              }
            : mapping

        if (project.is_master_set) {
            yield call(updateDocumentMapping, project.id, updateDocumentMappingDataToConformToAPI(modifiedMapping))
        }
        yield call(fetchDocumentChunksAndMappings, project.id)
    } catch (e) {
        yield call(console.error, `Error on API duplication: ${e}`)

        yield put(updateDocumentMappings(documentMappings))

        yield put(initializeDocumentChunks(documentChunks))
        yield put(initializeProjectDocumentsFromChunks(documentChunks))
    }
}

export function* watchForDuplicateDocumentChunk(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(duplicateDocumentChunkAction.type, handleDuplicateDocumentChunk)
}
